import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { MUNICIPALITY_STORAGE_KEY, URL } from "myconstants";
import { Action, State } from "state/state";
import cantonLogo from "assets/images/kantonslogo-luzern.svg";
import { useHistory } from "react-router-dom";
import { Select } from "components/common/Select";

export function Header(props: {
  dispatch: (action: Action) => void;
  state: State;
}) {
  async function logout() {
    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/users/logout`, {
        method: "POST",
        credentials: "include",
      });
    } finally {
      window.sessionStorage.removeItem(MUNICIPALITY_STORAGE_KEY);
      dispatch({ type: "signOut" });
      history.replace(URL.root);
    }
  }

  function onMunicipalityChange(bfsNr: string) {
    const selectedMunicipality = state.user.accessibleMunicipalities?.find(
      (m) => m.bfsNr.toString() === bfsNr
    );

    if (selectedMunicipality !== undefined) {
      dispatch({
        type: "setSelectedMunicipality",
        data: { municipality: selectedMunicipality },
      });

      window.sessionStorage.setItem(
        MUNICIPALITY_STORAGE_KEY,
        selectedMunicipality.bfsNr.toString()
      );
    }
  }

  const { dispatch, state } = props;
  const history = useHistory();

  return (
    <header className="relative h-80 shrink-0 bg-header bg-no-repeat bg-cover bg-center bg-gray-600 bg-blend-overlay w-full">
      <Link
        onClick={() => dispatch({ type: "clearAll" })}
        to={URL.root}
        className="absolute w-10 md:w-12 lg:w-14"
      >
        <SVG src={cantonLogo} />
      </Link>
      <ul className="absolute flex flex-col items-end space-y-8 top-8 right-8">
        <li>
          <ul className="flex flex-row items-center justify-end space-x-4">
            {state.user.user !== undefined && (
              <>
                <li className="text-white">{state.user.user.name}</li>
                <li>
                  <span
                    className="text-white font-bold hover:underline hover:text-white cursor-pointer"
                    onClick={logout}
                  >
                    Abmelden
                  </span>
                </li>
              </>
            )}
          </ul>
        </li>
        <li>
          <Select
            header={{ displayValue: "Gemeinde auswählen", enabled: false }}
            options={state.user.accessibleMunicipalities?.map((m) => {
              return { value: m.bfsNr.toString(), displayValue: m.gemeinde };
            })}
            value={state.selectedMunicipality?.bfsNr.toString()}
            width="w-auto"
            visible={true}
            onChange={(value) => onMunicipalityChange(value)}
          />
        </li>
      </ul>
    </header>
  );
}
